import { string, object } from '@gogame/schemas';

import {
  NAME,
  OWNER,
  PARTNER_COMPANY,
  CUSTOMER_COMPANY,
  INVOICE_LEVEL,
  CURRENCY,
  EXPENSE_TYPES,
  NETWORK,
  ADDRESS,
  STREET_ADDRESS,
  STREET_ADDRESS_2,
  CITY,
  POSTAL_CODE,
  COUNTRY,
  EMAIL,
  MOBILE,
  PHONE,
  CONTACT_PERSON,
  FIRST_NAME,
  LAST_NAME,
  NDA,
  DPA,
} from './constants';

export const BusinessPartnerFormValidationSchema = object({
  [NAME]: string().required('Name  is required'),
  [OWNER]: string().required('Owner  is required'),
  [PARTNER_COMPANY]: string().required('Partner company  is required'),
  [CUSTOMER_COMPANY]: string().required('Customer company  is required'),
  [INVOICE_LEVEL]: string().required('Invoice level  is required'),
  [CURRENCY]: string().required('Currency  is required'),
  [EXPENSE_TYPES]: string().required('Expense types  is required'),
  [NETWORK]: string().required('Network  is required'),
  [NDA]: object(),
  [DPA]: object(),
  [ADDRESS]: object({
    [STREET_ADDRESS]: string()
      .max(50, 'Address line 1  must be at most 50 characters')
      .required('Address line 1  is required'),
    [STREET_ADDRESS_2]: string().max(
      50,
      'Address line 2  must be at most 50 characters'
    ),
    [CITY]: string()
      .max(100, 'City  must be at most 100 characters')
      .required('City  is required'),
    [POSTAL_CODE]: string().max(
      20,
      'Zip / Postal code  must be at most 20 characters'
    ),
    [COUNTRY]: string().required('Country  is required'),
  }),
  [CONTACT_PERSON]: object({
    [FIRST_NAME]: string()
      .max(50, 'First name  must be at most 50 characters')
      .required('First name  is required'),
    [LAST_NAME]: string()
      .max(50, 'Last name  must be at most 50 characters')
      .required('Last name  is required'),
    [MOBILE]: string().max(50, 'Mobile  must be at most 50 characters'),
    [PHONE]: string().max(20, 'Phone  must be at most 20 characters'),
    [EMAIL]: string()
      .max(100, 'Email  must be at most 100 characters')
      .required('Email  is required'),
  }),
});
